import {
  RESET,
  SET_INFO,
  SET_SETTINGS,
  SET_STATUS,
  COMPILANCE_LIST,
  SET_CURVES,
  SET_TRANSFER,
  LOGIN_DETAILS,
  LOGIN,
  SET_DIAGNOSIS,
  SET_PASS,
  CLEAR_SELECTED_PATIENT,
  DIAGNOSIS_LOAD,
  SET_SELECTED_USER,
  PATIENTS_LIST,
  SET_ALL_PATIENTS,
  SET_ALL_ADMINS,
  SET_ERROR,
  SET_DIAGNOSIS_IMAGE,
} from './types';

import { authAxios } from '../../utils/AxiosHelper';
import {
  editUserClinicFunc,
  fillPatientsBuckets,
  fromByteArrToBase64,
  fromByteArrToImage,
  grantAdminRole,
  isUsers,
  removeAdminRole,
  setImage,
} from '../../utils/CFuncs';
import { closeModal, getClinicData, getPatients, getPatientsByClinicId, getUsers, getUsersByClinicId, navigateTo, setIsLoading, setSuccess } from './';
import { AdminAccessRole, patientStatus, urls } from '../../utils/Objects';
import axios from 'axios';
import { baseURL } from '../../env';
import { Items, Storage } from '../../utils/StorageHelper';
import store from '../store';

const handleErrorResponse = (error, dispatch, type) => {
  console.log('erro messaeg ');

  console.log(error.message);
  let errObj = error.response?.data?.errors;
  if (errObj && Object.keys(errObj).length > 0) {
    return dispatch({
      type,
      payload: Object.values(errObj).join(' '),
    });
  } else if (error.response) {
    return dispatch({
      type,
      payload: error.response.data,
    });
  } else if (error.request) {
    console.log(error.request);
    return dispatch({ type, payload: error.request });
  } else {
    return dispatch({ type, payload: error.message });
  }
};
// need to use it in the clietns side
export const getPaitentsWithNoClinic = () => {
  console.log('getPaitentsWithNoClinic statred');
  return (dispatch) => {
    authAxios
      .get('users/paitents/noclinic')
      .then((response) => {
        console.log('getPaitentsWithNoClinic done');
        console.log(response.data);
        let list = response.data ?? [];

        return dispatch({ type: PATIENTS_LIST, payload: fillPatientsBuckets(list) });
      })
      .catch((error) => {
        console.log('getPaitentsWithNoClinic fail');
        // Handle the error response
        console.error('Error get getPaitentsWithNoClinic:', error);
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const getPaitentsWithNoActive = () => {
  console.log('getPaitentsWithNoActive statred');
  const status = patientStatus.Inactive;
  return (dispatch) => {
    authAxios
      .get(`users/paitents/no-active`)
      .then((response) => {
        console.log('getPaitentsWithNoActive done');
        console.log(response.data);
        let list = response.data ?? [];

        return dispatch({ type: PATIENTS_LIST, payload: fillPatientsBuckets(list) });
      })
      .catch((error) => {
        console.log('getPaitentsWithNoActive fail');
        // Handle the error response
        console.error('Error get getPaitentsWithNoActive:', error);
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const activateUser = (token, email, callback) => {
  console.log('activateUser statred');
  return (dispatch) => {
    axios
      .post(baseURL + `/api/users/activate-user`, {
        token,
        email,
      })
      .then((response) => {
        console.log('activateUser done');
        dispatch(setSuccess('your account has been activated'));
        callback('your account has been activated');
        // navigateTo("/")
      })
      .catch((error) => {
        console.log('activateUser fail');
        callback('There was a problem to activate your account !', false);
        // Handle the error response
        console.error('Error activateUser:', error);
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

//  not in use for now
export const setSelectedUser = (user) => {
  return { type: SET_SELECTED_USER, payload: user };
};
export const editUserClinic = (user, roleAction, callback) => {
  console.log(' editUserClinic start');
  return (dispatch) => {
    const functionAdminRole = roleAction == AdminAccessRole.Grant ? grantAdminRole : removeAdminRole;
    return Promise.all([editUserClinicFunc(user), functionAdminRole(user.id)])
      .then(([data, isSuccess]) => {
        dispatch(setSuccess('User Edited successfully'));
        console.log(data, isSuccess);
        callback(data);
        dispatch(getUserDetails(user.id));
      })
      .catch((error) => {
        console.log(error.response);
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const getSettings = (userId) => {
  return (dispatch) => {
    let path = `users/${userId}/cobb/settings`;
    authAxios
      .get(path)
      .then((response) => {
        dispatch({ type: SET_SETTINGS, payload: response.data });
      })
      .catch((error) => {
        //if code 401 call refresh token
        dispatch(navigateTo('/'));
        dispatch({ type: SET_SETTINGS, payload: { error } });
      });
  };
};
export const clearSelectedPatient = () => {
  return { type: CLEAR_SELECTED_PATIENT, payload: {} };
};
export const getPatientDetails = (userId, onEndFetch) => {
  return (dispatch) => {
    let path = `users/${userId}/cobb/settings`;
    dispatch({ type: DIAGNOSIS_LOAD });

    authAxios
      .get(path)
      .then((response) => {
        dispatch({ type: SET_SETTINGS, payload: response.data });
        // onEndFetch();
      })
      .then(() => {
        return getPersonalInfo(userId);
      })
      .then((result) => {
        dispatch(result);
        return getCompilanceList(userId);
      })
      .then((result) => {
        dispatch(result);
        return getDiagnosis(userId);
      })
      .then((res) => dispatch(res))
      .catch((error) => {
        //if code 401 call refresh token
        dispatch(navigateTo('/'));
        dispatch({ type: SET_SETTINGS, payload: { error } });
      });
  };
};

function parseJwt(token) {
  if (!token) {
    return;
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const setSelectedPatient = (patient) => {
  return { type: SET_INFO, payload: patient };
};

const getPersonalInfo = (userId) => (dispatch) => {
  console.log('getPersonalInfo started');
  let path = `/users/${userId}/personal_info`;
  return authAxios
    .get(path)
    .then((response) => {
      console.log('getPersonalInfo done');
      dispatch({ type: SET_INFO, payload: response.data });
    })
    .catch((error) => {
      console.log('getPersonalInfo error: ' + error.message);
      handleErrorResponse(error, dispatch, SET_ERROR);
      //if code 401 call refresh token
      // return { type: SET_INFO, payload: { error } };
    });
};

export const getConnectedUser = (token) => {
  return (dispatch) => {
    let path = '/users/me';
    authAxios
      .get(path, { token: token })
      .then((response) => {
        dispatch({ type: LOGIN_DETAILS, payload: response.data });
        dispatch({ type: LOGIN, payload: true });
      })
      .catch((error) => {
        //if code 401 call refresh token
        //todo redirect to login page
        dispatch({ type: LOGIN_DETAILS, payload: { error } });
      });
  };
};

const getCompilanceList = (userId) => (dispatch) => {
  let path = `/users/${userId}/physical/daily?timezone=-2%3A00&limit=50`;
  return authAxios
    .get(path)
    .then((response) => {
      dispatch({ type: COMPILANCE_LIST, payload: response.data });
    })
    .catch((error) => {
      //if code 401 call refresh token
      handleErrorResponse(error, dispatch, SET_ERROR);

      return { type: COMPILANCE_LIST, payload: { error } };
    });
};

// export const getCurvesList = (userId) => {

//     return (dispatch) => {
//         let path = `/users/${userId}/spine/curves`
//         authAxios.get(path).then(response => {
//             console.log('Curves List response: ',response)
//             dispatch({ type: SET_CURVES, payload: response.data })

//         }).catch(error => {
//             //if code 401 call refresh token
//             console.log(error.response)
//             dispatch({ type: SET_CURVES, payload: { error } })
//         })
//     }
// }

export const getCurvesList = (userId) => {
  return (dispatch) => {
    dispatch({ type: SET_CURVES, payload: [] });
  };
};

export const getTransferList = (userId) => {
  // console.log("getTransferList",userId);
  return (dispatch) => {
    let path = `/users/${userId}/cobb/transfers?orderBy=id&sortOrder=desc&limit=101`;
    authAxios
      .get(path)
      .then((response) => {
        // console.log('Transfer List response: ', response.data)
        dispatch({ type: SET_TRANSFER, payload: response.data });
      })
      .catch((error) => {
        //if code 401 call refresh token
        dispatch(navigateTo('/'));
        dispatch({ type: SET_TRANSFER, payload: { error } });
      });
  };
};
// export const getTransferList = (userId) => {
//     return (dispatch) => {
//         console.log('Transfers:',transfers);
//         dispatch({ type: SET_TRANSFER, payload: transfers })
//     }
// }

const fetchData = (dispatch) => {
  const screenName = store.getState().nav.screenName
  const selectedClinic = store.getState().clinic.selectedClinic
  const clinicId = Storage.get(Items.clinicId);
  switch (screenName) {
    case urls.patients:
      if (clinicId) {
        if (!selectedClinic) dispatch(getClinicData(clinicId))
        dispatch(getPatientsByClinicId(clinicId ))
      } else {
        dispatch(getPatients( ))
      }
      break;
    case urls.users:
      if (clinicId) {
        if (!selectedClinic) dispatch(getClinicData(clinicId))
        dispatch(getUsersByClinicId(clinicId))
      }else {
        dispatch(getUsers())
      }
      break;
      case urls.admins:
        dispatch(getAdmins())
      break;
      
      default:
      break;
  }

  dispatch(getUsers())
}

export const setStatus = (userId, status, onSuccess) => {
  return (dispatch) => {
    let path = `users/${userId}/status`;
    authAxios
      .put(path, status)
      .then((response) => {
        console.log('response.data here: ', response.data);
        dispatch({ type: SET_STATUS, payload: Number(response.data.status) });
        onSuccess();
        dispatch(setSuccess('status is updated'));
        fetchData(dispatch)
      })
      .catch((error) => {
        //if code 401 call refresh token
        // dispatch({ type: SET_STATUS, payload: { error } });
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const setSettings = (userId, settings, callback = () => {}) => {
  return (dispatch) => {
    let path = `users/${userId}/cobb/settings`;
    authAxios
      .put(path, settings)
      .then((response) => {
        dispatch({ type: SET_SETTINGS, payload: response.data });
        dispatch(setSuccess('Goal is successfully updated'));
        callback();
      })
      .catch((error) => {
        //if code 401 call refresh token
        dispatch(navigateTo('/'));
        dispatch({ type: SET_SETTINGS, payload: { error } });
        handleErrorResponse(error, dispatch, SET_ERROR);
        callback();
      });
  };
};

const getDiagnosis = (userId) => (dispatch) => {
  let path = `users/${userId}/diagnosis`;
  return authAxios
    .get(path)
    .then((response) => {
      dispatch({ type: SET_DIAGNOSIS, payload: response.data });
    })
    .catch((error) => {
      handleErrorResponse(error, dispatch, SET_ERROR);
    });
};

export const setDiagnosis = (userId, diagnosisObj, callback) => {
  return (dispatch) => {
    let path = `users/${userId}/diagnosis`;
    authAxios
      .post(path, diagnosisObj)
      .then((response) => {
        dispatch({ type: SET_DIAGNOSIS, payload: response.data });
        dispatch(setSuccess('Diagnostics updated successfully'));
        callback();
        dispatch(closeModal());
      })
      .catch((error) => {
        // handleErrorResponse(error, dispatch,SET_ERROR);
        throw new Error(error);
      });
  };
};

export const saveAllDiagnostics = (userId, diagnosisObj, image, callback) => {
  return async  (dispatch) => {
    dispatch({ type: DIAGNOSIS_LOAD });
    let imageId = null;
    if (image) {
      imageId = await setImage(image);
    }

    const diagnosisImageObj = { ...diagnosisObj, imageId };
    dispatch(setDiagnosis(userId, diagnosisImageObj, callback));
  };
};
export const setNewPass = (userId, pass) => {
  return (dispatch) => {
    let path = `users/${userId}/resetPassword`;
    authAxios
      .post(path, { password: pass })
      .then((response) => {
        dispatch(setSuccess('Password updated successfully'));
      })
      .catch((error) => {
        //if code 401 call refresh token
        handleErrorResponse(error, dispatch, SET_ERROR);
        dispatch({ type: SET_PASS, payload: { error } });
      });
  };
};
export const getUserDetails = (userId) => {
  console.log(' getUserDetails start');
  return (dispatch) => {
    let path = `user/${userId}/with-roles`;
    authAxios
      .get(path)
      .then((response) => {
        console.log(' getUserDetails success');
        dispatch({ type: SET_SELECTED_USER, payload: response.data });
      })
      .catch((error) => {
        console.log(error);
        console.log(' getUserDetails fail');
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const getAllPatients = () => {
  console.log(' getAllPatients start');
  return (dispatch) => {
    let path = `users/all-patients`;
    authAxios
      .get(path)
      .then((response) => {
        console.log(' getAllPatients success');
        dispatch({ type: SET_ALL_PATIENTS, payload: fillPatientsBuckets(response.data) });
      })
      .catch((error) => {
        console.log(error);
        console.log(' getAllPatients fail');
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const resetUser = () => {
  return (dispatch) => {
    dispatch({ type: RESET, payload: null });
  };
};

export const setAdmins = (payload) => {
  return (dispatch) => {
    return dispatch({ type: SET_ALL_ADMINS, payload: payload });
  };
};
export const getAdmins = () => {
  console.log('getAdmins statred');
  return (dispatch) => {
    dispatch(setIsLoading(true))
    
    authAxios
    .get(`/user/admins`)
    .then((response) => {
      console.log('getAdmins done');
      console.log(response.data);
      dispatch(setIsLoading(false))
      return dispatch({ type: SET_ALL_ADMINS, payload: response.data });
    })
    .catch((error) => {
      console.log('getAdmins fail');
      dispatch(setIsLoading(false))

        // navigateTo(urls.clinicDetails)

        console.error('Error get the users:', error);
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};
